import CardHeights from './CardHeights';
import Video from './Video';
import Link from './Link';
import Helper from './Helper';
import HorizontalScroll from './HorizontalScroll';
import TableTitle from './TableTitle';
import ProjectTeaser from './ProjectTeaser';
import Tagmanager from './Tagmanager';
import LazyLoad from 'vanilla-lazyload';

class Overlay {
  constructor(config = {}) {
    const {
      overlayButtonSelector,
      overlayTagmagButtonSelector,
      openerSelector,
      openerTagSelector
    } = config;


    this.body = document.querySelector("body");
    this.overlayButtonSelector = overlayButtonSelector;
    this.overlayTagmagButtonSelector = overlayTagmagButtonSelector;
    this.overlayButtons = Array.prototype.slice.call(document.querySelectorAll(this.overlayButtonSelector));
    this.overlayTagmagButton = document.querySelector(this.overlayTagmagButtonSelector);
    this.overlayElement = document.querySelector('.ns-overlay');
    this.overlayInnerElement = document.querySelector('.ns-overlay__inner');
    this.body = document.querySelector('body');
    this.content = document.querySelector('.content');
    this.sidenav = document.querySelector('.sidenav');
    this.sidebar = document.querySelector('.sidebar');
    this.footer = document.querySelector('footer');
    this.heroElement = document.querySelector('.ns-anchor-container--hero .ns-anchor-container__content');
    this.videoInstance = null;
    this.linkInstance = null;
    this.horizontalScrollInstance = null;
    this.typeOfOverlay = null;
    this.tableTitleInstance = null;
    this.projectTeaserInstance = null;
    this.tagmanagerInstance = null;

    this.opener = document.querySelectorAll(openerSelector);
    this.openerTag = openerTagSelector;

    this.clickHash = window.location.hash.replace('#', '');
    this.pathLength = window.location.pathname.split('/').filter(value => value != '').length;

    if(this.clickHash != '' && this.pathLength <= 3){
      this.bindLoadHashtag(".sidebar__button", true);
    }

    if (this.overlayButtons && this.overlayButtons.length !== 0) {
      this.bindEvents();
    }

    if (this.overlayTagmagButton) {
      this.bindTagmagEvents();
    }

    if(this.opener.length !== 0){
      this.bindOpenerEvents();
    }
  }

  bindLoadHashtag(classButtons, projects = false){
    let clickButton;
    let clickFired = false;
    let itemsChecked = 0;

    document.querySelectorAll(classButtons).forEach((button, index, array) => {

      itemsChecked++;
      let load = button.getAttribute("href");
      if(load){
        load = load.split('/').filter(value => value != '');
        load = load[load.length - 1];

        if(load == this.clickHash){
          clickButton = button.classList.toString().replace(' ','.');
          clickFired = true;
        }
      }
      if(itemsChecked == array.length){
        this.bindShowHashtag(clickButton, clickFired, projects);
      }
    });
  }

  bindShowHashtag(clickButton, clickFired, projects){
    let clickEvent = new Event('click');

    if(clickFired){
      setTimeout(e => {
        document.querySelector('.' + clickButton + '[href*=' + this.clickHash + ']').dispatchEvent(clickEvent);
      },100);
    } else if(projects){
      projects = false;
      setTimeout(e => {
          document.querySelector('.sidebar__button--projekte').dispatchEvent(clickEvent);

          let getProjects = setInterval(e => {
            if(document.querySelectorAll('.ns-project-teaser__link.loaded').length > 0){
              clearInterval(getProjects);
              this.bindLoadHashtag('.ns-project-teaser__link', false);
            }
          },100);

      },100);
    }
  }

  bindOpenerEvents(){
    this.opener.forEach(el => {
      el.addEventListener('click', e => {
        e.preventDefault();

        let hashtag = '';

        if(el.classList.contains(this.openerTag.replace(/\./g,''))) {
          hashtag = el.innerText.replace(/\#/g,'').trim();
        } else if(el.querySelector(this.openerTag)) {
          hashtag = el.querySelector(this.openerTag).innerText.replace(/\#/g,'').replace(/(\&shy;|­|&#173;)/gi, '').trim();
        }

        this.openTagmag(hashtag);
      });
    });
  }

  bindEvents(ca4n = false) {
    this.overlayButtons.forEach(el => {
      el.addEventListener("click", (e) => {
        e.preventDefault();

        let pageToDisplay = el.href;
        this.overlayInnerElement.style.display = "none";
        this.overlayInnerElement.style.opacity = 0;
        this.sidenav.style.display = "none";
        this.sidebar.style.display = "none";
        this.footer.style.display = "none";

        this.body.classList.add("overlay-open");
        this.content.classList.add("content--inactive");

        let language = document.querySelector("html").getAttribute("lang");

        if ( Helper.hasClass(el, 'sidebar__button--dashboard') ) {
          this.typeOfOverlay = "ns-overlay--dashboard";
          if(language == "de-DE"){
            this.overlayElement.querySelector(".sidebar__text").innerText = "Dashboard schließen";
          } else {
            this.overlayElement.querySelector(".sidebar__text").innerText = "Close Dashboard";
          }
        } else if ( Helper.hasClass(el, 'sidebar__button--projekte') ) {
          this.typeOfOverlay = "ns-overlay--projekte";
          if(language == "de-DE"){
            this.overlayElement.querySelector(".sidebar__text").innerText = "Projekte schließen";
          } else {
            this.overlayElement.querySelector(".sidebar__text").innerText = "Close Projects";
          }
        } else if ( Helper.hasClass(el, 'sidebar__button--factsheet') ) {
          if(language == "de-DE"){
            this.overlayElement.querySelector(".sidebar__text").innerText = "Factsheet schließen";
          } else {
            this.overlayElement.querySelector(".sidebar__text").innerText = "Close Factsheet";
          }
          this.typeOfOverlay = "ns-overlay--factsheet";
        }

        Helper.addClass(this.overlayElement, this.typeOfOverlay);

        this.overlayElement.style.opacity = 0;

        if ( !!this.heroElement ) {
          let image = this.heroElement.style.backgroundImage;
          this.overlayElement.querySelector('.ns-overlay__background').style.backgroundImage = image;
        }

        Helper.unfade(this.overlayElement);

        // this.getData(pageToDisplay).then((post) => {
        //   let url = window.location.origin + window.location.pathname;
        //   let splitted = url.split('/');
        //   splitted.length = 6;
        //   let joined = splitted.join('/');
        //   window.location.href = window.location.origin + window.location.pathname + "#" + post.seo.url.replace(joined,'').replace('/', '');

        //   console.log("response", post.content);

        //   this.overlayInnerElement.innerHTML = post.content;

        //   new CardHeights({
        //     cardContainerSelector: 'ns-two-col-container',
        //     cardSelector: 'ns-card__content'
        //   });
        // });

        // let overlayContainer = `<div class="ns-overlay ns-overlay--projekte show"><div class="ns-overlay__background"></div>`;

        let xhr = new XMLHttpRequest();

        xhr.onreadystatechange = () => {
          if(xhr.readyState === 4) {
            if(xhr.status === 200) {

              Helper.unfade(this.overlayInnerElement);
              this.footer.style.display = "block";

              setTimeout(e => {
                this.videoInstance = new Video();
                this.linkInstance = new Link({
                  linksSelector: '.js-target-blank'
                });
                this.horizontalScrollInstance = new HorizontalScroll({
                  containerSelector: '.ns-table-wrap > div'
                });
                this.tableTitleInstance = new TableTitle({
                  tableWrapper: '.ns-outer-table-wrapper',
                  tableTitleClass: '.ns-tbl-head_top',
                  tableTitlePosition: '.ns-table-title'
                });
                this.projectTeaserInstance = new ProjectTeaser({
                  projectTeaserLink: '.ns-project-teaser__link'
                });
                new LazyLoad();
              }, 1000);

              document.querySelector('html').classList.remove("ns-p-loading");

              let parser = new DOMParser();
              let dom = parser.parseFromString(xhr.responseText, 'text/html');

              let canonical = dom.querySelector('link[rel="canonical"]').getAttribute('href')
              let url = window.location.origin + window.location.pathname;
              let splitted = url.split('/');
              splitted.length = 6;
              let joined = splitted.join('/');
              canonical = canonical.replace(joined,'').replace('/', '');
              let urlPath = window.location.origin + window.location.pathname + "#" + canonical.replace('/', '');
              window.history.pushState("","", urlPath);

              this.overlayInnerElement.innerHTML += dom.querySelector('.content').innerHTML;
            }
          }
        }

        xhr.open('GET', pageToDisplay);

        xhr.send(null);

        Helper.addClass(this.overlayElement, 'show');

        this.overlayElement.querySelector('.sidebar__button.close').addEventListener('click', (e) => {
          this.closeOverlay();
        });

      });
    });
  }

  bindTagmagEvents(){
    this.overlayTagmagButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.openTagmag();
    });
  }

  openTagmag(hashtag){
    this.overlayInnerElement.style.display = "none";
    this.overlayInnerElement.style.opacity = 0;
    this.sidenav.style.display = "none";
    this.sidebar.style.display = "none";
    this.footer.style.display = "none";

    this.body.classList.add("overlay-open");
    this.content.classList.add("content--inactive");

    let language = document.querySelector("html").getAttribute("lang");

    this.typeOfOverlay = "ns-overlay--tagmanager-copy";
    if(language == "de-DE"){
      this.overlayElement.querySelector(".sidebar__button").classList.add("js-close-tm");
      this.overlayElement.querySelector(".sidebar__text").innerText = "Tagmanager schließen";
    } else {
      this.overlayElement.querySelector(".sidebar__button").classList.add("js-close-tm");
      this.overlayElement.querySelector(".sidebar__text").innerText = "Close Tagmanager";
    }

    Helper.addClass(this.overlayElement, this.typeOfOverlay);

    this.overlayElement.style.opacity = 0;

    Helper.unfade(this.overlayElement);

    this.overlayInnerElement.innerHTML = document.querySelector('.ns-overlay--tagmanager .ns-overlay__inner').innerHTML;

    Helper.addClass(this.overlayElement, 'show');

    this.tagmanagerInstance = new Tagmanager({
      tagSelector: ".js-tagmag-indikator-tag",
      allFilterSelector: ".js-tagmag-filter-all",
      removeFilterSelector: ".js-tagmag-filter-remove",
      resultsSelector: ".js-tagmag-results",
      openerTagSelector: hashtag
    });

    Helper.unfade(this.overlayInnerElement);
    this.footer.style.display = "block";

    window.scrollTo(0,0);

    this.overlayElement.querySelector('.sidebar__button.close').addEventListener('click', (e) => {
      this.closeOverlay();
    });
  }

  closeOverlay() {
    this.body.classList.remove("overlay-open");
    this.content.classList.remove("content--inactive");
    this.overlayInnerElement.innerHTML = "";
    this.sidenav.style.display = "block";
    this.sidebar.style.display = "grid";
    if(this.overlayElement.querySelector(".sidebar__button").classList.contains("js-close-tm") && document.querySelector(".ns-anchor-container--themenfilter")){
      const yOffset = -50;
      const y =  document.querySelector(".ns-anchor-container--themenfilter").getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({top: y, behavior: 'auto'});
    }
    this.overlayElement.querySelector(".sidebar__button").classList.remove("js-close-tm");
    Helper.fade(this.overlayElement);
    Helper.removeClass(this.overlayElement, 'show');
    Helper.removeClass(this.overlayElement, 'ns-overlay--projekte');
    Helper.removeClass(this.overlayElement, 'ns-overlay--tagmanager-copy');
    Helper.removeClass(this.overlayElement, 'ns-overlay--factsheet');
    Helper.removeClass(this.body, 'no-scroll');

    let urlPath = window.location.origin + window.location.pathname;
    window.history.pushState("","", urlPath);

    new LazyLoad();
  }

  // getData(restUrl) {
  //   return fetch(restUrl, {
  //     headers: {
  //      'X-WP-Token': NSContext.token
  //     }})
  //     .then((response) => {
  //       if(response.ok) {
  //         Helper.unfade(this.overlayInnerElement);
  //         this.footer.style.display = "block";
  //         setTimeout(e => {
  //           this.videoInstance = new Video();
  //           this.linkInstance = new Link({
  //             linksSelector: '.js-target-blank'
  //           });
  //           this.horizontalScrollInstance = new HorizontalScroll({
  //             containerSelector: '.ns-table-wrap > div'
  //           });
  //           this.tableTitleInstance = new TableTitle({
  //             tableWrapper: '.ns-outer-table-wrapper',
  //             tableTitleClass: '.ns-tbl-head_top',
  //             tableTitlePosition: '.ns-table-title'
  //           });
  //           this.projectTeaserInstance = new ProjectTeaser({
  //             projectTeaserLink: '.ns-project-teaser__link'
  //           });
  //         }, 1000);
  //         return response.json();
  //       }
  //       else {
  //         if(this.typeOfOverlay.includes("projekte")){
  //           window.location.href += "#projekte";
  //         } else {
  //           window.location.href += "#factsheet";
  //         }
  //         location.reload();
  //       }
  //     })
  // }
} export default Overlay;
